import {
  Accordion,
  Box,
  Flex,
  ProfileIcon,
  Typography,
} from '@iheartjane/reefer';
import truncate from 'lodash-es/truncate';

import type { JaneUser } from '@jane/shared/data-access';
import { formatPhone, formatTime } from '@jane/shared/util';

import styles from './MenuQuickCheckoutDrawer.module.css';

interface QuickCheckoutCustomerDetailsProps {
  janeUser: JaneUser | undefined;
}

export const QuickCheckoutCustomerDetails = ({
  janeUser,
}: QuickCheckoutCustomerDetailsProps) => (
  <Box className={styles['checkoutAccordionItem']}>
    <Accordion.Item id="customer-details">
      <Accordion.Heading>
        <Flex gap={16}>
          <div>
            <ProfileIcon />
          </div>
          <Flex flexDirection="column">
            <Typography variant="body-semibold">Customer details</Typography>
            <Accordion.Summary>
              <Typography>
                {truncate(`${janeUser?.user.name}, ${janeUser?.user.email}`, {
                  length: 40,
                })}
              </Typography>
            </Accordion.Summary>
          </Flex>
          <Flex ml="auto">
            <Accordion.Indicator iconSize="md" />
          </Flex>
        </Flex>
      </Accordion.Heading>
      <Accordion.Content>
        <Flex flexDirection="column" mx={40}>
          <Typography>{janeUser?.user.name}</Typography>
          <Typography>{janeUser?.user.email}</Typography>
          <Typography>
            {!!janeUser?.user.birth_date &&
              formatTime({
                time: janeUser.user.birth_date,
                outputFormat: 'MM/DD/YYYY',
                inputFormat: 'YYYY-MM-DD',
              })}
            , {!!janeUser?.user.phone && formatPhone(janeUser.user.phone)}
          </Typography>
        </Flex>
      </Accordion.Content>
    </Accordion.Item>
  </Box>
);
